import { Injectable } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { SessionService } from '@monsido/core/session/session.service';
import { UrlService } from '@uirouter/core';
import { IconsService } from '@layout/icons/icons.service';
import { CoreDomainService } from '@client/app/core/services/domain/core-domain.service';

@Injectable({
    providedIn: 'root',
})
export class PagesTabsHelper {
    private tabs: any[] = [];
    private availableTabs: any[] = [];
    private scanDocuments = false;

    constructor (
        private sessionService: SessionService,
        private location: UrlService,
        private monEventService: MonEventService,
        private translateService: TranslateService,
        private iconsService: IconsService,
        private coreDomainService: CoreDomainService,
    ) {
        this.initTabs();
        this.init();
    }

    private initTabs () : void {
        this.tabs = [
            {
                name: this.translateService.getString('All'),
                faIcon: this.iconsService.getIcon(['TABS', 'PAGES', 'ALL']),
                value: 'all',
            },
            {
                name: this.translateService.getString('Pages'),
                faIcon: this.iconsService.getIcon(['TABS', 'PAGES', 'HTML']),
                value: 'html',
            },
            {
                name: this.translateService.getString('PDF Documents'),
                faIcon: this.iconsService.getIcon(['TABS', 'PAGES', 'PDF']),
                value: 'pdf',
            },
            {
                name: this.translateService.getString('Other Documents'),
                faIcon: this.iconsService.getIcon(['TABS', 'PAGES', 'DOCUMENT']),
                value: 'document',
            },
        ];
        this.availableTabs = this.tabs;
    }

    private init (): void {
        this.checkScanDocument();
        this.coreDomainService.onDomainChanged.subscribe(() => {
            this.checkScanDocument();
        });
    }

    getTabs (): any[] {
        return this.availableTabs;
    }

    getActiveTab (attr?: string): string | null {
        attr = attr || 'type';
        this.checkScanDocument();
        return this.scanDocuments ? this.location.search()[attr] || null : 'html'; // Default type to html if scan_documents are false
    }

    private checkScanDocument (): void {
        const domain = this.sessionService.domain;
        if (!domain) {
            return;
        }
        this.scanDocuments = domain.scan?.scan_documents ?? false;
        this.availableTabs = this.scanDocuments ? this.tabs : [];
    }
}
